import parser from './parser';

const name = 'input';


export default {parser, name};
